<template>
  <f7-page class="home-page">
    <template #fixed>
      <MainHeaderComponent />
    </template>

    <div class="bg-gray title-container">
      <div class="title">
        <font-awesome-icon :icon="['fad', 'chart-area']" fixed-width />
        <div class="text">
          <h1>{{ $t.getTranslation("LBL_PRODUCT_FEATURED_LIST") }}</h1>
          <h3></h3>
        </div>
      </div>

      <div class="button-container">
        <f7-button preloader large fill raised @click="add()">{{ $t.getTranslation("LBL_ADD") }}</f7-button>
        <!-- <f7-button large icon="far fa-fw fa-cog"></f7-button> -->
      </div>
    </div>


   <section class="form-container" >
      <div class="container" >
         <div v-if="list.length > 0" >
             <h2>{{ $t.getTranslation("LBL_PRODUCT_DRAG_MESSAGE") }}</h2>
            <draggable class="dragArea list-group w-full" :list="list" @change="log" :move="checkMove">
              <div
                class="list-group-item bg-gray-300 m-1 p-3 rounded-md text-center"
                v-for="(item, index) in list"
                :key="item.ProductId"
              >
              <!-- {{ element.id }} -->
               <div style="margin-bottom: 10px;">
                  <span class="badge color-blue"> {{ index + 1 }}</span>
               </div>
               <ProductListCardComponent :data="item.Product" :f7router="f7router" :viewProductStatus="status" />
              </div>
            </draggable>
         </div>
          <NoDataFoundComponent v-else :size="'lg'" :title="$t.getTranslation('LBL_NO_PRODUCTS_FOUND')" />
      </div>

    </section>
    <MainFooterComponent />
  </f7-page>
</template>

<script>
import { defineComponent, ref, computed, onMounted, inject } from "vue";
import MainHeaderComponent from "@/components/MainHeaderComponent.vue";
import MainFooterComponent from "@/components/MainFooterComponent.vue";
import NoDataFoundComponent from "@/components/NoDataFoundComponent.vue";
import ProductListCardComponent from "@/components/cards/ProductListCardComponent.vue";
import { VueDraggableNext } from 'vue-draggable-next';


import { $HTTP } from "@/utils/axios";
import { helpers } from "@/utils/helpers";
import { useStore } from "@/store";

export default defineComponent({
  name: "ProductFeatureList",
  components: {
    MainHeaderComponent,
    MainFooterComponent,
    draggable: VueDraggableNext,
    ProductListCardComponent
  },
  props: { f7router: Object },
  setup(props) {
    const $t = inject("$translation");
    const store = useStore();
    const currentLanguageCode = computed(() => store.getters["translation/getLanguage"]);
    const list = ref([]);
    const drag = ref(null);
    let page = 1;
    let size = 30;

    const getData = async () => {
      try {
        helpers.showLoader();
        let res = await $HTTP.get(`/admin/product/list?page=${page}&size=${size}&mode=FEATURED&LanguageCode=${currentLanguageCode.value || 'EN'}`);
        if (res?.status === 200 && res?.data?.data.data) {
          helpers.hideLoader();
          for (var i = 0; i < res.data.data.data.length; i++) {
            let item = res.data.data.data[i];
            item.id = (i+1);
            if (item?.ProductKey) {
              item.Product['ProductKey'] = item.ProductKey;
            }
          }
          list.value = res.data.data.data;
          helpers.hideLoader();
          return;
        }
        //throw new Error($t.getTranslation("ERR_SERVER_NOT_RESPONDING"));
      } catch (err) {
        helpers.hideLoader();
        helpers.catchError(err, true);
      }
    };

    const log = (event) => {
      // console.log(event.moved.element)
      // console.log(event.moved)
      // console.log(drag.value)
      if (list.value) {
       savePosition(list.value); 
      }
    }

    const checkMove = (event) => {
      //console.log(event)
      //savePosition();
    }

    const savePosition = async(list) => {
      //call the function to save positon..
      try {
        helpers.showLoader();
        let res = await $HTTP.post(`/admin/product/featured/position`, { List: list});
        if (res?.status === 200 && res?.data?.data) {
          helpers.createNotification({ type: "success", title: $t.getTranslation("LBL_SUCCESS"), message: $t.getTranslation("LBL_SUCCESSFULLY_PRODUCT_POSITION") });
          helpers.hideLoader();
          return;
        }
        throw new Error($t.getTranslation("ERR_SERVER_NOT_RESPONDING"));
      } catch (err) {
        helpers.hideLoader();
        helpers.catchError(err, true);
      }
    }

    const status = async(productkey) => {
      props.f7router.navigate({ name: "productMarketing", query: { key: productkey, isFeatured: 1 } });
    }

    const add = async() => {
      props.f7router.navigate({ name: "productList", query: { isFeatured: 1 } });
    }

    onMounted(async() => {
      await getData();
    });
  
    return {
      list,
      log,
      checkMove,
      status,
      add
    };
  },
});
</script>

<style scoped>
.custom-container {
  min-height: 600px;
}
.default-img {
  width: 100px;
  height: 100px;
}

.form-container .container{
  display: flex;
  margin: 0px 0px;
  /* padding: 40px 0px 40px 40px; */
  width: 90%;
  justify-content: center;
  align-items: center;
}

li::marker{
  color: #fff;
}

</style>
